module.exports = __webpack_public_path__ + "img/ic-close.4338e67a.svg";